var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAbFBMVEVHcEyJYmKPXl2QXl2P Xl6AgICAVVWQXl2PXlyPXV2PYGCQXl2QXl6QXl2QXV2QX12qVVWAQED/AACQXV2RXl6SX1+RXl2Q Xl6QXl6RX12QXlyRX1+PXl6QXl2SW1uQXl6QXl2QXV2QXl3////VTZkgAAAAInRSTlMADbDzkAIG w6BSMP1q/mWnAwQBR21GnWeeZmwzVMUOsfKOWr2sdQAAAAFiS0dEIypibDoAAAAHdElNRQfoBQUO OjTHfkvLAAAAaElEQVQ4y+XQNxaAQAhFUQxjzjkH9r9IC7STodHC42/vOxQA0AzTshXwc1xE9DSF j6gvglAqolgqErqRZg8U+S+K66eFVJRsUFFQC95w3pJ36iXvP+7D+T/OR8FhEhycWe8Ay7rtt34A vCEaiUeKK4wAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjQtMDUtMDVUMTQ6NTg6NTIrMDA6MDD0p91F AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDI0LTA1LTA1VDE0OjU4OjUyKzAwOjAwhfpl+QAAACh0RVh0 ZGF0ZTp0aW1lc3RhbXAAMjAyNC0wNS0wNVQxNDo1ODo1MiswMDowMNLvRCYAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7a6c45a25947da2fca8d1c6c14dd0cc8.svg";
export { ForwardRef as ReactComponent };